/*eslint-disable*/ export const messages = {
    'Add "{inputValue}"': ['"', ["inputValue"], '" を追加'],
    "All items have been removed.": "すべての項目が削除されました。",
    "Clear selection": "選択のクリア",
    "No results found.": "何も見つかりませんでした。",
    "Select All": "すべて選択",
    "Selected Items": "選択した項目",
    "Toggle menu": "メニューの切り替え",
    "listbox contents": "リストボックスの内容",
    "{itemAsString} has been removed.": ['"', ["itemAsString"], '" が削除されました。'],
    "{itemAsString} has been selected.": ['"', ["itemAsString"], '" が選択されました。'],
    "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.":
        [
            ["resultCount", "plural", { one: ["#", " 件の結果"], other: ["#", " 件の結果"] }],
            "があります。移動するには上下矢印キーを使用します。選択するには Enter キーを押します。",
        ],
    "{selectedValue} selected": [["selectedValue"], " 個選択"],
};
